// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"b39de908","806":"48b7272c","902":"670013c2"}[chunkId] + ".chunk.css";
};